import RecordmImporterLineStatM from "./recordm.importer.model.stat.line.js";
import RecordmImporterSummaryStatM from "./recordm.importer.model.stat.summary.js";

const RecordmImporterStatsM = function(core) {
    let rowStats = [];
    let summaryStats = [];
    let total = 0;

    return {
        addStats: function(esHits){
            total = esHits.total.value || 0;

            esHits.hits.forEach(function(statJson) {
                let stat;

                if(RecordmImporterSummaryStatM.isSummaryStat(statJson)){
                    stat = new RecordmImporterSummaryStatM(core, statJson);
                    summaryStats.push(stat);
                } else {
                    stat = new RecordmImporterLineStatM(core, statJson);
                    rowStats.push(stat);
                }

                core.addModel(stat.getModelKey(), stat);
            });
        },
        clear: function(){
            total = 0;
            rowStats = [];
            summaryStats = [];
        },
        getNumStats: function() {
            return summaryStats.length + rowStats.length;
        },
        getAllStats: function(){
            return summaryStats.concat(rowStats);
        },
        getTotal: function(){
            return total;
        },
        getSummaryForImportId: function(importId) {
            return summaryStats.filter((stat) => stat.getImportId() === importId)[0];
        },
        getLineStatsForImportId: function(importId) {
            return rowStats.filter((stat) => stat.getImportId() === importId);
        }
    }
};

export default RecordmImporterStatsM;
